/**
	WPFetch
	*/

import WDFetch from './wd-fetch';

class WPFetch extends WDFetch {

	__className = 'WPFetch';
	
	constructor(cfg,values)
	{
		const restURL = WPRestSettings.url;

		//remove the trailing slash from the rest url before setting
		//add the WP Nonce header also		
		const baseCfg = { baseURL: restURL.substr(0,restURL.length-1),
											headers: { 'X-WP-Nonce': WPRestSettings.nonce }
										};
								
		if (cfg) 
		{
			//passed a uri, set it up as the baseURI for the query
			if (typeof(cfg) == 'string') baseCfg.baseURI = cfg;
			else Object.assign(baseCfg,cfg);
		}
								
		super(baseCfg,values);
  };

};

export default WPFetch;